import React from "react"
import { FaEdit, FaTrash } from "react-icons/fa"

export const parseRankingTable = ({
  data,
  onStatusClick,
  onEditClick,
  onDeleteClick,
}) => {
  const columns = [
    {
      field: "Empresa",
      headerName: "Empresa",
      flex: 1.5,
      renderCell: params => (
        <div>{params.row.Empresa ? params.row.Empresa : "N/A"}</div>
      ),
    },
    {
      field: "Lote",
      headerName: "Lote",
      flex: 1,
      renderCell: params => (
        <div>{params.row.Lote ? params.row.Lote : "N/A"}</div>
      ),
    },
    {
      field: "PalavraChave",
      headerName: "Palavra Chave",
      flex: 1.5,
      renderCell: params => (
        <div>{params.row.PalavraChave ? params.row.PalavraChave : "N/A"}</div>
      ),
    },
    {
      field: "Ranking",
      headerName: "Ranking",
      flex: 1,
      renderCell: params => (
        <div>{params.row.Ranking ? params.row.Ranking : "N/A"}</div>
      ),
    },
    {
      field: "Setor",
      headerName: "Setor",
      flex: 1.5,
      renderCell: params => (
        <div>{params.row.Setor ? params.row.Setor : "N/A"}</div>
      ),
    },
    {
      field: "ReceitaLiquida",
      headerName: "Receita Líquida",
      flex: 1,
      renderCell: params => (
        <div>
          {params.row.ReceitaLiquida
            ? `R$ ${params.row.ReceitaLiquida}`
            : "N/A"}
        </div>
      ),
    },
    {
      field: "UFSede",
      headerName: "UF Sede",
      flex: 0.7,
      renderCell: params => (
        <div>{params.row.UFSede ? params.row.UFSede : "N/A"}</div>
      ),
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 0.7,
      renderCell: params => (
        <div
          style={{
            color: params.row.Status ? "green" : "inherit",
            cursor: "pointer",
          }}
          onClick={() => onStatusClick(params.row)}
        >
          {params.row.Status ? "Ativo" : "Inativo"}
        </div>
      ),
    },
    {
      field: "Editar",
      headerName: "Editar",
      flex: 0.5,
      renderCell: params => (
        <div
          style={{
            cursor: "pointer",
            width: "100%",
            height: "100%",
          }}
          onClick={() => onEditClick(params.row)}
        >
          <FaEdit size={18} color="green" />
        </div>
      ),
    },
    {
      field: "Excluir",
      headerName: "Excluir",
      flex: 0.7,
      renderCell: params => (
        <div
          style={{
            cursor: "pointer",
            height: "100%",
          }}
          onClick={() => onDeleteClick(params.row)}
        >
          <FaTrash size={16} color="red" />
        </div>
      ),
    },
  ]

  const rows = data ? data.map(company => ({ ...company, id: company.Id })) : []

  return { columns, rows }
}
